"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorStatusCode = void 0;
/** Should be used for HTTP REST requests, not GraphQL. */
var ErrorStatusCode;
(function (ErrorStatusCode) {
    ErrorStatusCode["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ErrorStatusCode["OUTDATED_VERSION"] = "OUTDATED_VERSION";
    ErrorStatusCode["TOO_MANY_REQUESTS"] = "TOO_MANY_REQUESTS";
    ErrorStatusCode["UNAUTHENTICATED"] = "UNAUTHENTICATED";
    ErrorStatusCode["UNAUTHORIZED"] = "UNAUTHORIZED";
})(ErrorStatusCode || (exports.ErrorStatusCode = ErrorStatusCode = {}));
